var options = {
  path: '/mediadata',
  title: ' 媒资库',
  icon: 'wpforms',
  hideSub: true,
  children: ((pre) => [

    { path: `${pre}myfile`, title: '我的文件', icon: 'dot-circle-o' },
    { path: `${pre}myshare`, title: '我的共享', icon: 'dot-circle-o' },
    { path: `${pre}depfile`, title: '部门文件', icon: 'dot-circle-o' },
    { path: `${pre}publicfile`, title: '公共文件', icon: 'dot-circle-o' },
    { path: `${pre}face`, title: '人脸管理', icon: 'dot-circle-o' }

  ])('/mediadata/')
}

export default options
